import _ from 'underscore';
import Backbone from 'backbone';
import { toText, toShort } from '../../utils';
import { state } from '../../state-manager/state-model';

import tpl from './excess-money.template.ejs';

function getMembershipName(grade) {
  switch (grade) {
    case 'none':
      return '일반 회원';
    case 'gold':
      return '골드클래스';
    case 'silver':
      return '실버클래스';
    case 'royal':
      return '로얄클래스';
    default:
      return '일반';
  }
}

export var ExcessMoneyView = Backbone.View.extend({
  tagName: 'div',

  className: 'popup-excess',

  template: tpl,

  initialize: function () {},

  events: {
    'click [data-role=closeExcessMoney]': 'close'
  },

  getDerivedContext: function () {
    var data = this.model.attributes;

    var currentMoneyText = toText(toShort(data.totalMoney), { delimiter: ' ' }) + '냥';
    var excessMoneyText = toText(toShort(data.excessMoney), { delimiter: ' ' }) + '냥';
    var maxMoneyText = toText(data.maxMoney, { delimiter: ' ' }) + '냥';

    var game = state.get('game');
    var membership = state.get('membership');
    var membershipName = getMembershipName(membership);
    var userName = $.trim($('.profile__name').text());
    var excessExpiredAt = '';

    if (data.excessMoneyExpireDate) {
      excessExpiredAt = data.excessMoneyExpireDate.replace(
        /(\d\d\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)/,
        '$1년 $2월 $3일 $4:$5'
      );
    }

    var context = _.extend(
      {
        game: game,
        userName: userName,
        maxMoneyText: maxMoneyText,
        currentMoneyText: currentMoneyText,
        membership: membership,
        membershipName: membershipName,
        excessMoneyText: excessMoneyText,
        excessExpiredAt: excessExpiredAt
      },
      data
    );

    return context;
  },

  render: function () {
    var context = this.getDerivedContext();
    this.$el.html(this.template(context));
    $(document.body).append(this.$el);

    return this;
  },

  close: function () {
    this.remove();
  }
});
